var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ecommerce_1_",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 115 115",
    style: {
      enableBackground: "new 0 0 115 115"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ffeead}.st2{fill:#99734a}.st3{fill:#ff6f69}.st4{fill:#96ceb4}.st7{fill:#71a58a}.st11{fill:#e05858}.st19{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SEO_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.257 55.893a2.138 2.138 0 0 0-3.004-.34L65.48 79.28 50.275 67.549a2.136 2.136 0 0 0-2.864.229L31.739 84.472a2.139 2.139 0 0 0 1.558 3.601c.569 0 1.138-.227 1.558-.674L49.2 72.119l14.995 11.569c.78.602 1.868.593 2.638-.02l31.085-24.772a2.136 2.136 0 0 0 .339-3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M34.939 94.703h-1.632a3.446 3.446 0 0 0-3.436 3.436v9.396a3.446 3.446 0 0 0 3.436 3.436h1.632a3.446 3.446 0 0 0 3.436-3.436v-9.396a3.446 3.446 0 0 0-3.436-3.436zM50.356 82.37h-1.632a3.446 3.446 0 0 0-3.436 3.436v21.729a3.446 3.446 0 0 0 3.436 3.436h1.632a3.446 3.446 0 0 0 3.436-3.436V85.806a3.447 3.447 0 0 0-3.436-3.436zM65.772 90.592H64.14a3.445 3.445 0 0 0-3.435 3.436v13.507a3.446 3.446 0 0 0 3.435 3.436h1.632a3.446 3.446 0 0 0 3.436-3.436V94.028a3.447 3.447 0 0 0-3.436-3.436zM81.188 83.398h-1.632a3.446 3.446 0 0 0-3.436 3.436v20.701a3.446 3.446 0 0 0 3.436 3.436h1.632a3.446 3.446 0 0 0 3.436-3.436V86.833a3.446 3.446 0 0 0-3.436-3.435zM96.605 69.009h-1.632a3.446 3.446 0 0 0-3.436 3.436v35.09a3.446 3.446 0 0 0 3.436 3.436h1.632a3.446 3.446 0 0 0 3.436-3.436v-35.09a3.447 3.447 0 0 0-3.436-3.436z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 33.298,
    cy: 85.935,
    r: 4.282
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 49.026,
    cy: 69.34,
    r: 4.282
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 65.672,
    cy: 81.824,
    r: 4.282
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 80.372,
    cy: 69.9,
    r: 4.282
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 95.788,
    cy: 57.5,
    r: 4.282
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.466 23.985H43.803c-6.344 0-11.534 5.19-11.534 11.534v2.009c0 6.344 5.19 11.534 11.534 11.534h59.663c6.344 0 11.534-5.19 11.534-11.534v-2.009c0-6.344-5.19-11.534-11.534-11.534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.363 26.613H44.906c-5.451 0-9.911 4.46-9.911 9.911s4.46 9.911 9.911 9.911h57.458c5.451 0 9.911-4.46 9.911-9.911-.001-5.452-4.461-9.911-9.912-9.911z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.363 26.612h-8.091v19.822h8.091c5.451 0 9.911-4.46 9.911-9.911s-4.46-9.911-9.911-9.911z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m25.749 52.296-1.546-.756a3.265 3.265 0 0 0-4.354 1.494l-7.408 15.149a3.265 3.265 0 0 0 1.494 4.354l1.546.756a3.265 3.265 0 0 0 4.354-1.494l7.408-15.149a3.265 3.265 0 0 0-1.494-4.354z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m17.496 68.138-.73-.357c-2.666-1.304-5.913-.189-7.217 2.476L.545 88.672c-1.304 2.666-.189 5.913 2.477 7.217l.73.357c2.666 1.304 5.913.189 7.217-2.477l9.005-18.414c1.303-2.666.188-5.914-2.478-7.217z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 33.871,
    cy: 33.73,
    r: 29.693
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 33.871,
    cy: 33.73,
    r: 27.168
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 33.871,
    cy: 33.73,
    r: 25.254
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.443 13.134H19.257a25.14 25.14 0 0 0-8.068 9.501C5.833 33.588 9.126 46.523 18.41 53.698h30.93a25.001 25.001 0 0 0 7.223-8.874c5.521-11.292 1.839-24.801-8.12-31.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M21.33 33.005c-.852-.601-2.274-1.517-3.159-2.117-1.169-.791-2.022-1.391-2.022-2.434 0-.821.663-1.39 1.486-1.39.474 0 1.105.127 1.422.948.063.221.127.474.189.727.348 1.075 1.264 1.548 2.275 1.548 1.106 0 2.528-.664 2.528-2.781 0-.506-.064-1.58-.885-2.655-1.454-1.926-4.013-2.117-5.34-2.117-4.36 0-7.079 2.465-7.079 6.605 0 3.571 2.339 5.055 4.424 6.415.538.347 1.042.695 1.58 1.042 1.484.916 2.402 1.516 2.402 2.749 0 .916-.695 1.864-1.928 1.864-.506 0-1.39-.189-1.737-1.295-.096-.316-.126-.663-.158-1.011-.064-.506-.158-1.075-.663-1.548-.443-.443-1.012-.664-1.707-.664-1.833 0-2.717 1.486-2.717 3.191 0 2.307 1.295 3.95 3.097 4.803 1.231.569 2.717.759 4.013.759 4.804 0 7.457-2.844 7.457-6.763-.002-3.412-1.929-4.834-3.478-5.876zM39.149 41.568c-.695-.759-1.611-.759-2.432-.759h-4.298v-4.802h3.665c.885 0 2.275-.032 2.749-1.422.095-.317.127-.6.127-.791a2.25 2.25 0 0 0-.506-1.454c-.631-.695-1.611-.726-2.37-.758h-3.665V27.6h4.045c.759 0 1.801 0 2.496-.663.411-.347.663-.885.663-1.58 0-2.306-2.274-2.306-3.191-2.306h-5.814c-.916 0-1.896 0-2.717.663-1.042.822-1.042 2.085-1.042 3.065v14.948c0 1.105 0 2.148.79 2.874.791.759 1.864.759 2.938.759h6.067c.823 0 1.771 0 2.466-.727.41-.379.6-.948.6-1.516-.001-.316-.033-.98-.571-1.549zM55.927 25.737c-1.548-2.623-4.519-3.034-6.541-3.034-1.739 0-3.508.285-4.962 1.265-2.559 1.737-2.685 4.581-2.685 9.164 0 6.129 0 8.499 1.675 10.395 1.896 2.118 5.087 2.118 5.941 2.118 1.454 0 4.708-.126 6.447-2.623.978-1.422 1.263-2.97 1.263-8.027-.001-6.32-.316-7.837-1.138-9.258zm-4.582 13.114c-.032.601-.158 2.211-1.928 2.211-1.864 0-1.926-1.801-1.99-3.665-.032-1.012-.032-2.022-.032-3.034 0-1.264 0-3.981.126-5.087.064-.536.221-1.958 1.801-1.958 1.201 0 1.739.727 1.928 1.991.126.916.158 3.633.158 4.834.001.093-.031 3.981-.063 4.708z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m21.345 68.689-7.376-3.607a3.366 3.366 0 0 0-4.489 1.541 3.366 3.366 0 0 0 1.54 4.489l7.376 3.607a3.366 3.366 0 0 0 4.489-1.541 3.366 3.366 0 0 0-1.54-4.489z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M51.891 18.113c-9.082-10.041-24.64-10.821-34.682-1.741a1.953 1.953 0 0 0-.138 2.755c.723.799 1.955.86 2.755.138 8.446-7.638 21.532-6.982 29.172 1.465a1.95 1.95 0 0 0 2.893-2.617z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.d1b12781b032b4e9007e5090e4fda978.svg";
export { ForwardRef as ReactComponent };